export const sharedColors = {
  orange: '#fab14d',
  black: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
  white: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
  buttonColor: '#fec2c55',
  textColor: '#121212',
  pink: 'rgb(254, 44, 85)',
  inputHover: '#808d97',
}
